import type { ApiTableModel } from 'components/ApiTable/model/ApiTableModel';
import { reloadTableDataInViewport } from 'components/ApiTable/model/commands/reloadTableDataInViewport';
import { hasSomeColumnAppeared } from 'components/Table/helpers/hasSomeColumnAppeared';
import { AUTO_SIZED_COLUMNS_DEFAULT } from 'components/Table/model/TableModel';
import { requestAutoSize } from 'components/Table/model/commands/requestAutoSize';
import { useEffectOnChange } from 'utils/react/useEffectOnChange';

export const useReloadOnAddedColumns = (model: ApiTableModel): void => {
  const { columnVisibility, autoSizedColumns = AUTO_SIZED_COLUMNS_DEFAULT } =
    model.tableModel.settings;

  useEffectOnChange(() => {
    if (
      hasSomeColumnAppeared(
        model.tableModel.columns,
        model.lastLoadColumnVisibility,
        columnVisibility,
      )
    ) {
      model.dispatch(reloadTableDataInViewport);
      if (autoSizedColumns) {
        model.tableModel.dispatch(requestAutoSize);
      }
    }
  }, [columnVisibility]);
};
